import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { Box, Button, Grow, InputAdornment, Tooltip } from '@mui/material';
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import React from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { Settings } from '@mui/icons-material';

import PresetSelector from '@/components/datagrid/PresetSelector';

const AlarmDataGridToolbar = ({
  setOpenEditAlarmGroupDialog,
  useFeed,
  setUseFeed,
  ...props
}) => {
  const [showToolbar, setShowToolbar] = React.useState(false);
  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        alignItems: 'center',
        my: 1,
        background: 'inherit',
      }}
    >
      <GridToolbarQuickFilter
        size="small"
        sx={{
          '& .MuiInputBase-root': {
            backgroundColor: (theme) => theme.palette.background.paper,
            borderRadius: 2,
          },
          '& .MuiFilledInput-root': {
            borderRadius: '5px',
          },
          '& .MuiInput-underline:before, & .MuiInput-underline:after': {
            display: 'none',
          },
          '& .MuiInputLabel-root': {
            color: 'gray',
          },
        }}
        variant="outlined"
        InputProps={{
          placeholder: 'Søg alarmer...',
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon sx={{ color: 'gray' }} />
            </InputAdornment>
          ),
        }}
      />
      <ToggleButtonGroup
        value={useFeed ? 'feed' : 'plain'}
        size="small"
        exclusive
        onChange={(event, newValue) => {
          if (newValue !== null) {
            setUseFeed(newValue === 'feed');
          }
        }}
        sx={{ mb: 0.5, backgroundColor: 'background.paper', borderRadius: 2 }}
      >
        <ToggleButton size="small" value="feed">
          Feed
        </ToggleButton>
        <ToggleButton size="small" value="plain">
          Alle
        </ToggleButton>
      </ToggleButtonGroup>
      <PresetSelector {...props} />

      <Box
        sx={{
          flexGrow: 1,
          justifyContent: 'flex-end',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Grow in={showToolbar}>
          <GridToolbar />
        </Grow>

        <Tooltip
          title={showToolbar ? 'Hide Options' : 'Show Options'}
          placement="top"
        >
          <Button
            startIcon={showToolbar ? <FilterListOffIcon /> : <FilterListIcon />}
            variant="outlined"
            size="small"
            onClick={() => setShowToolbar(!showToolbar)}
            sx={{
              borderRadius: 2,
              borderColor: 'divider',
              backgroundColor: 'background.paper',
              ':hover': { borderColor: 'divider' },
              textTransform: 'none',
              p: 0.9,
              color: 'text.primary',
            }}
          >
            {showToolbar ? 'Skjul indstillinger' : 'Vis indstillinger'}
          </Button>
        </Tooltip>

        <Button
          variant="outlined"
          size="small"
          startIcon={<Settings />}
          onClick={() => setOpenEditAlarmGroupDialog(true)}
          sx={{
            borderRadius: 2,
            borderColor: 'divider',
            backgroundColor: 'background.paper',
            textTransform: 'none',
            ':hover': { borderColor: 'divider' },
            p: 0.9,
            color: 'text.primary',
          }}
        >
          Alarmgrupper
        </Button>
      </Box>
    </GridToolbarContainer>
  );
};

export default AlarmDataGridToolbar;
